import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import propTypes from "prop-types";
import classes from "./FilterContainer.scss";
import { updateOrganizationFilters } from "Tooling/modules/ToolingModule";
import {
  SearchInput,
  Dropdown,
  DropdownMenu,
  ButtonDisclosure,
} from "@toddle-edu/ds-web";
import classNames from "classnames";

import {
  CURRICULUM_PLANS_OPTIONS,
  IS_PAID_ORGANIZATION_OPTIONS,
} from "Tooling/modules/ToolingUtils";

const FilterContainer = props => {
  const {
    searchText,
    changeSearchTerm,
    toddleBuddies,
    buddyFilterValue,
    planFilterValue,
    updateOrganizationFilters,
    showPlanFilter,
    totalCount,
    isPaidOrgFilterValue,
  } = props;

  const selectedBuddy = _.find(
    toddleBuddies,
    ({ id }) => id == buddyFilterValue
  );

  const getToddleBuddyList = () => {
    return [
      { label: "All", key: "" },
      ..._.map(toddleBuddies, ({ id, firstName, lastName }) => ({
        label: `${firstName || ""} ${lastName || ""}`,
        key: id,
      })),
    ];
  };

  const onPlanItemClick = ({ key }) => {
    updateOrganizationFilters({ plan: key });
  };

  const onBuddyItemClick = ({ key }) => {
    updateOrganizationFilters({ toddleBuddy: key });
  };

  const onIsPaidOrgItemClick = ({ key: selectedKey }) => {
    updateOrganizationFilters({
      isPaidOrganizationKey: selectedKey,
    });
  };

  const selectedBuddyLabel = _.get(selectedBuddy, "firstName", "") || "All";

  const buddyFilterLabel = `Toddle buddy: ${selectedBuddyLabel}`;

  const selectedSchoolType = _.find(IS_PAID_ORGANIZATION_OPTIONS, {
    key: isPaidOrgFilterValue,
  });

  const selectedSchoolTypeLabel =
    _.get(selectedSchoolType, "label", "") || "All";

  const isPaidOrgFilterLabel = `School type: ${selectedSchoolTypeLabel}`;

  const selectedPlan = _.find(
    CURRICULUM_PLANS_OPTIONS,
    ({ key }) => key == planFilterValue
  );

  const selectedPlanLabel = _.get(selectedPlan, "label", "") || "All";

  const planFilterLabel = `Plan : ${selectedPlanLabel}`;

  const schoolHeadingCountClass = classNames("heading-6", {
    [classes.schoolCountHeading]: true,
  });
  return (
    <div className={classes.header}>
      <div className={classes.leftHeader}>
        <div className={classes.searchHeader}>
          <SearchInput
            onChange={changeSearchTerm}
            value={searchText}
            placeholder={`Search by school name or ID`}
          />
        </div>
        <div className={schoolHeadingCountClass}>{totalCount} Schools</div>
      </div>
      <div className={classes.rightHeader}>
        <Dropdown
          overlay={
            <DropdownMenu
              options={getToddleBuddyList()}
              onClick={onBuddyItemClick}
            />
          }
        >
          <ButtonDisclosure variant="plain">
            {buddyFilterLabel}
          </ButtonDisclosure>
        </Dropdown>
        <Dropdown
          overlay={
            <DropdownMenu
              options={IS_PAID_ORGANIZATION_OPTIONS}
              onClick={onIsPaidOrgItemClick}
            />
          }
        >
          <ButtonDisclosure variant="plain">
            {isPaidOrgFilterLabel}
          </ButtonDisclosure>
        </Dropdown>

        {showPlanFilter && (
          <Dropdown
            overlay={
              <DropdownMenu
                options={CURRICULUM_PLANS_OPTIONS}
                onClick={onPlanItemClick}
              />
            }
          >
            <ButtonDisclosure variant="plain">
              {planFilterLabel}
            </ButtonDisclosure>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

FilterContainer.defaultProps = {
  showPlanFilter: true,
};

FilterContainer.propTypes = {
  showPlanFilter: propTypes.bool,
};

const mapActionCreators = {
  updateOrganizationFilters,
};
export default connect(null, mapActionCreators)(FilterContainer);

FilterContainer.displayName = "FilterContainer";
